






























import AnalyzeCustomServices, { AnalyzeCustomDto, DataItem, IndicatorInfo } from '@/services/analyzeCustom';
import { Vue, Component } from 'vue-property-decorator';
import EWall from './e-wall.vue';
import CustomTableView from './custom-table-view.vue';
import CustomFunnelView from './custom-funnel-view.vue';
import { getRange } from '@/libs/time';
import moment from 'moment';
@Component({
  components: { CustomTableView, CustomFunnelView, EWall }
})
export default class Todo extends Vue {
  customSrv = new AnalyzeCustomServices();

  date: string = moment().format('YYYY-MM-DD');
  dateRange: string[] = getRange('week');
  reload: number = 0;

  created() {
    this.getInfo();
  }

  setFilterDate() {
    let [startTime, endTime] = this.dateRange;
    this.indicatorInfo.dataDate = this.date;
    this.indicatorInfo.startTime = startTime;
    this.indicatorInfo.endTime = endTime;
    this.dataItem.startTime = startTime;
    this.dataItem.endTime = endTime;
    this.reload++;
  }

  resetFilterDate() {
    this.date = moment().format('YYYY-MM-DD');
    this.dateRange = getRange('week');
    this.reload++;
  }

  info: AnalyzeCustomDto = {};
  dataItem: DataItem = {};
  indicatorInfo: IndicatorInfo = {};
  async getInfo() {
    let code = this.$route.query.code;
    let info: any = await this.customSrv.getInfo(code);
    let [startTime, endTime] = this.dateRange;
    this.info = info;
    let dataItem = JSON.parse(info.dataItem);
    this.dataItem = { ...dataItem, startTime, endTime };
    let indicatorInfo = JSON.parse(info.indicatorInfo);
    this.indicatorInfo = { ...indicatorInfo, startTime, endTime, dataDate: this.date };
  }
}
